import { DeleteOutline, Lock } from "@mui/icons-material";
import { IconButton, Stack, Tooltip, Typography } from "@mui/material";
import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid-premium";
import moment from "moment";
import { AttachmentImage, DATE_TIME_FORMAT } from "../../components";
import { Attachment } from "../../redux/slices/material";
import { DataGridColumnDimension } from "../viewSettings/types";

export const DashboardTableColumn = (onDelete: any, view: any, getPath: (id: string) => string, dimensions: DataGridColumnDimension, orderedFields: string[], hideDelete?: boolean) => {

    const columns: GridColDef[] = [
        {
            field: 'sequence_id', headerName: 'Project ID', width: dimensions?.sequence_id?.width || 120, renderCell: (params: GridRenderCellParams) => {
                if (params.rowNode.type === 'group') {
                    return params.value;
                }
                return (
                    <Stack direction="row" spacing={1} sx={{
                        alignItems: "center"
                    }}>
                        <Typography
                            id="view-project-icon"
                            component={"a"}
                            href={getPath(params.row?._id)}
                            onClick={(e) => {
                                e.preventDefault();
                                view(params.row);
                            }}
                            variant="body2"
                            color="primary"
                            sx={{ cursor: "pointer", textDecoration: "underline" }}>
                            {params.row.sequence_id}
                        </Typography>
                        {params.row?.user_access ? <Tooltip title={`This ${params.row.sequence_id} is private`}><Lock color='disabled' fontSize={"small"} /></Tooltip> : <></>}
                    </Stack>
                );
            }
        },
        {
            field: "attachments",
            headerName: "Image",
            width: dimensions?.attachments?.width || 70,
            renderCell: (params: GridRenderCellParams) => {

                let attachment = params?.row?.attachments?.find((attachment: Attachment) => attachment?.is_primary);

                if (!attachment) {
                    attachment = params?.row?.attachments?.at(-1)
                }

                return <AttachmentImage object_id={params.row._id} object_type="project" {...(attachment ?? {})} />
            },
            disableColumnMenu: true,
            sortable: false,
        },
        // {
        //     field: 'type', headerName: 'Type', width: 150,
        //     valueGetter: (value, row, column, apiRef) => { return row.tags_info?.filter((_: any) => _.tag_group_canonical_name === TAG_CANONICAL_NAMES.proj_category)?.[0]?.tag_name ?? "" },
        //     renderCell: (params: GridRenderCellParams) => {
        //         if (params.rowNode.type === 'group') {
        //             if (params.rowNode.groupingField === 'type') {
        //                 return params.rowNode.groupingKey;
        //             }
        //             return '';
        //         }
        //         return (
        //             <Stack
        //                 spacing={1}
        //                 direction={"row"}
        //                 id={"tagsChip"}
        //                 sx={{
        //                     width: "100%",
        //                 }}>
        //                 {params.row.tags_info?.filter((_: any) => _.tag_group_canonical_name === TAG_CANONICAL_NAMES.proj_category).map((tag: any) => <Chip variant="outlined" sx={{ borderColor: tag.tag_group_color, backgroundColor: tag.tag_group_color, color: `${hexToGrayscale(tag.tag_group_color) > 150 ? "rgba(0, 0, 0, 0.87)" : "#FFFFFF"}` }} size={"small"} label={tag?.tag_name ?? ""} />)}
        //             </Stack>
        //         );
        //     },
        //     groupingValueGetter: (value, row, column, apiRef) => {
        //         return row.tags_info?.filter((_: any) => _.tag_group_canonical_name === TAG_CANONICAL_NAMES.proj_category)?.[0]?.tag_name ?? "";
        //     },
        //     disableColumnMenu: true,
        //     sortable: false,
        // },
        {
            field: 'project_name', headerName: 'Project Name', width: dimensions?.project_name?.width || 200, renderCell: (params: GridRenderCellParams) => {
                if (params.rowNode.type === 'group') {
                    return params.value;
                }
                return <Tooltip title={params.row.project_name}>
                    <Typography variant="body2" sx={{ width: "100%", overflow: "hidden", textOverflow: "ellipsis" }}>
                        {params.row.project_name}
                    </Typography>
                </Tooltip>
            }
        },
        { field: 'reference_number', headerName: 'Reference Number', width: dimensions?.reference_number?.width || 150 },
        { field: 'serial_num', headerName: 'Sequence No.', width: dimensions?.serial_num?.width || 150 },
        { field: 'cost_center', headerName: 'Cost Center', width: dimensions?.cost_center?.width || 150, valueGetter: (value, row, column, apiRef) => `${row?.cost_center ?? ""} ` },
        // {
        //     field: 'Business Unit', headerName: 'Business Unit', width: 150,
        //     valueGetter: (value, row, column, apiRef) => { return row.tags_info?.filter((_: any) => _.tag_group_canonical_name === TAG_CANONICAL_NAMES.business_units)?.[0]?.tag_name ?? "" },
        //     renderCell: (params: GridRenderCellParams) => {
        //         if (params.rowNode.type === 'group') {
        //             if (params.rowNode.groupingField === 'Business Unit') {
        //                 return params.rowNode.groupingKey;
        //             }
        //             return '';
        //         }
        //         return (
        //             <Stack
        //                 spacing={1}
        //                 direction={"row"}
        //                 id={"tagsChip"}
        //                 sx={{
        //                     width: "100%",
        //                 }}>
        //                 {params.row.tags_info?.filter((_: any) => _.tag_group_canonical_name === TAG_CANONICAL_NAMES.business_units).map((tag: any) => <Chip variant="outlined" sx={{ borderColor: tag.tag_group_color, backgroundColor: tag.tag_group_color, color: `${hexToGrayscale(tag.tag_group_color) > 150 ? "rgba(0, 0, 0, 0.87)" : "#FFFFFF"}` }} size={"small"} label={tag?.tag_name ?? ""} />)}
        //             </Stack>
        //         );
        //     },
        //     groupingValueGetter: (value, row, column, apiRef) => {
        //         return row.tags_info?.filter((_: any) => _.tag_group_canonical_name === TAG_CANONICAL_NAMES.business_units)?.[0]?.tag_name ?? "";
        //     },
        //     disableColumnMenu: true,
        //     sortable: false,
        // },
        { field: 'project_manager', headerName: 'Project Mgr / Lead', width: dimensions?.project_manager?.width || 150 },
        { field: 'customer_name', headerName: 'Customer', width: dimensions?.customer_name?.width || 150 },
        // {
        //     field: 'tags_info', headerName: 'Tags', width: 250,
        //     valueGetter: (value, row, column, apiRef) => { return row.tags_info?.filter((_: any) => _.tag_group_canonical_name === TAG_CANONICAL_NAMES.proj_general)?.[0]?.tag_name ?? "" },
        //     renderCell: (params: GridRenderCellParams) => {
        //         if (params.rowNode.type === 'group') {
        //             if (params.rowNode.groupingField === 'tags_info') {
        //                 return params.rowNode.groupingKey;
        //             }
        //             return '';
        //         }
        //         <Stack
        //             spacing={1}
        //             direction={"row"}
        //             id={"tagsChip"}
        //             sx={{
        //                 width: "100%",
        //             }}>
        //             {params.row.tags_info?.filter((_: any) => _.tag_group_canonical_name === TAG_CANONICAL_NAMES.proj_general).map((tag: any) => <Chip variant="outlined" sx={{ borderColor: tag.tag_group_color, color: tag.tag_group_color }} size={"small"} label={tag?.tag_name ?? ""} />)}
        //         </Stack>
        //     },
        //     groupingValueGetter: (value, row, column, apiRef) => {
        //         return row.tags_info?.filter((_: any) => _.tag_group_canonical_name === TAG_CANONICAL_NAMES.proj_general)?.[0]?.tag_name ?? "";
        //     },
        // },
        {
            field: 'start_date', headerName: 'Start Date', width: dimensions?.start_date?.width || 250, renderCell: (params: GridRenderCellParams) => {
                return <Typography variant="body2">{moment(params.row.start_date).format(DATE_TIME_FORMAT)}</Typography>
            }
        },
        {
            field: 'finish_date', headerName: 'End Date', width: dimensions?.finish_date?.width || 250, renderCell: (params: GridRenderCellParams) => {
                return <Typography variant="body2">{moment(params.row.finish_date).format(DATE_TIME_FORMAT)}</Typography>
            }
        },
        // {
        //     field: 'status', headerName: 'Status', width: 150,
        //     valueGetter: (value, row, column, apiRef) => { return row.tags_info?.filter((_: any) => _.tag_group_canonical_name === TAG_CANONICAL_NAMES.proj_status)?.[0]?.tag_name ?? "" },
        //     renderCell: (params: GridRenderCellParams) => {
        //         if (params.rowNode.type === 'group') {
        //             if (params.rowNode.groupingField === 'status') {
        //                 return params.rowNode.groupingKey;
        //             }
        //             return '';
        //         }
        //         return (
        //             <Stack
        //                 spacing={1}
        //                 direction={"row"}
        //                 id={"tagsChip"}
        //                 sx={{
        //                     width: "100%",
        //                 }}>
        //                 {params.row.tags_info?.filter((_: any) => _.tag_group_canonical_name === TAG_CANONICAL_NAMES.proj_status).map((tag: any) => <Chip variant="outlined" sx={{ borderColor: tag.tag_group_color, backgroundColor: tag.tag_group_color, color: `${hexToGrayscale(tag.tag_group_color) > 150 ? "rgba(0, 0, 0, 0.87)" : "#FFFFFF"}` }} size={"small"} label={tag?.tag_name ?? ""} />)}
        //             </Stack>
        //         );
        //     },
        //     groupingValueGetter: (value, row, column, apiRef) => {
        //         return row.tags_info?.filter((_: any) => _.tag_group_canonical_name === TAG_CANONICAL_NAMES.proj_status)?.[0]?.tag_name ?? "";
        //     },
        //     disableColumnMenu: true,
        //     sortable: false,
        // },
        // {
        //     field: 'priority', headerName: 'Priority', width: 150,
        //     valueGetter: (value, row, column, apiRef) => { return row.tags_info?.filter((_: any) => _.tag_group_canonical_name === TAG_CANONICAL_NAMES.project_priority)?.[0]?.tag_name ?? "" },
        //     renderCell: (params: GridRenderCellParams) => {
        //         if (params.rowNode.type === 'group') {
        //             if (params.rowNode.groupingField === 'status') {
        //                 return params.rowNode.groupingKey;
        //             }
        //             return '';
        //         }
        //         return (
        //             <Stack
        //                 spacing={1}
        //                 direction={"row"}
        //                 id={"tagsChip"}
        //                 sx={{
        //                     width: "100%",
        //                 }}>
        //                 {params.row.tags_info?.filter((_: any) => _.tag_group_canonical_name === TAG_CANONICAL_NAMES.project_priority).map((tag: any) => <Chip variant="outlined" sx={{ borderColor: tag.tag_group_color, backgroundColor: tag.tag_group_color, color: `${hexToGrayscale(tag.tag_group_color) > 150 ? "rgba(0, 0, 0, 0.87)" : "#FFFFFF"}` }} size={"small"} label={tag?.tag_name ?? ""} />)}
        //             </Stack>
        //         );
        //     },
        //     groupingValueGetter: (value, row, column, apiRef) => {
        //         return row.tags_info?.filter((_: any) => _.tag_group_canonical_name === TAG_CANONICAL_NAMES.project_priority)?.[0]?.tag_name ?? "";
        //     },
        //     disableColumnMenu: true,
        //     sortable: false,
        // },
        { field: 'created_user', headerName: 'Created By', width: dimensions?.created_user?.width || 150 },
        {
            field: 'created_time', headerName: 'Created Date', width: dimensions?.created_time?.width || 250, renderCell: (params: GridRenderCellParams) => {
                if (params.rowNode.type === 'group') {
                    return params.value;
                }
                return <Typography variant="body2">{moment(params.row.created_time).format('lll')}</Typography>
            }
        },
        { field: 'modified_user', headerName: 'Last modified by', width: dimensions?.modified_user?.width || 150 },
        {
            field: 'modified_time', headerName: 'Last modified date', width: dimensions?.modified_time?.width || 250, renderCell: (params: GridRenderCellParams) => {
                if (params.rowNode.type === 'group') {
                    return params.value;
                }
                return <Typography variant="body2">{params.row.modified_time ? moment(params.row.modified_time).format('lll') : ""}</Typography>
            }
        },
        {
            field: 'delete', headerName: 'Delete', width: dimensions?.delete?.width || 100, renderCell: (params: GridRenderCellParams) => {
                return <IconButton onClick={() => onDelete(params.row)}>
                    <DeleteOutline color="error" id="delete-project-icon" />
                </IconButton>
            },
            disableColumnMenu: true,
            sortable: false,
        },
    ];

    if (hideDelete) {
        columns.pop();
    }

    if (orderedFields?.length === columns.length && orderedFields?.length > 0) {
        columns.sort((col1, col2) => orderedFields.indexOf(col1.field) - orderedFields.indexOf(col2.field))
    }

    return columns;
};